import { styled } from '../../base-components';
import { Autocomplete } from '@mui/material';

export const StyledAutoComplete = styled(Autocomplete)(({ theme }) => {
    return {
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(0.5),
        '&.MuiFormHelperText-root': {
            position: 'absolute',
            top: '100%',
        },
        '.Mui-error': {
            '&.MuiFormHelperText-root': {
                position: 'absolute',
                top: '100%',
                marginTop: '0px',
                marginInlineStart: theme.spacing(1),
            },
        },
    };
});
